import Legend from "@arcgis/core/widgets/Legend";
import { Dispatch, forwardRef, SetStateAction, useImperativeHandle, useRef } from "react";

import "./ClassRailroadVisible.css";

import { Sheet, SheetRef } from "react-modal-sheet";
import { ClassIRailroadLegendHandle } from "./ClassRailroadWrapper";

interface iProps {
  view: __esri.MapView;
  classIRailroadsVisible: boolean;
  classIRailroadLayer: __esri.GroupLayer | undefined;
  setClassIRailroadsVisible: Dispatch<SetStateAction<boolean>>;
}

const ClassRailroadMobile = forwardRef<ClassIRailroadLegendHandle, iProps>(
  ({
    view,
    classIRailroadsVisible,
    classIRailroadLayer,
    setClassIRailroadsVisible
  }, ref) => {


    useImperativeHandle(ref, () => ({
      toggleClassIRailroadsVisible
    }));

    const legendRef = useRef<Legend>();
    const legendContainerRef = useRef<HTMLDivElement | null>(null);

    const sheetRef = useRef<SheetRef>();
    const snapTo = (i: number) => sheetRef.current?.snapTo(i);

    const toggleClassIRailroadsVisible = () => {
      if (!classIRailroadLayer) return;

      const isVisible = !classIRailroadLayer.visible;
      classIRailroadLayer.visible = isVisible;
      classIRailroadLayer.layers.forEach(layer => { layer.visible = isVisible; });

      setClassIRailroadsVisible(isVisible);
    }

    const onOpenStart = () => {
      if (!legendRef.current) {
        legendRef.current = new Legend({
          view: view,
          layerInfos: [{
            layer: view.map.layers
              .find(layer => layer.title === 'Class I Railroads')
          }]
        });
      }

      if (legendContainerRef.current) {
        legendRef.current.container = legendContainerRef.current;
      }
    }

    const onCloseHandler = () => legendRef.current = undefined;

    return (
      <Sheet
        ref={sheetRef}
        isOpen={classIRailroadsVisible}
        onClose={() => snapTo(1)}
        onCloseEnd={onCloseHandler}
        snapPoints={[1, 25]}
        onOpenStart={onOpenStart}
        detent="content-height"
        style={{
          width: '50%'
        }}
      >
        <Sheet.Container>
          <Sheet.Header className="react-modal-sheet-header-container"/>
          <Sheet.Content>
            <div ref={legendContainerRef} id="legend-container"></div>
          </Sheet.Content>
        </Sheet.Container>
      </Sheet>
    );
  });

export default ClassRailroadMobile;